import { isArray } from 'util';
import { mapCollection, sortByNumber } from '../../utils/collection.utils';
import { parseNumber } from '../../utils/number.utils';
import { OperationalStatus } from '../operational-status';

export class OperationalStatusBuilder {
  static fromJson(json) {
    return (json)
      ? new OperationalStatus(
        parseNumber(json.code),
        json.label,
        parseNumber(json.order)
      )
      : null;
  }

  static fromList(list) {
    return (isArray(list)) ?
      sortByNumber(
        'order',
        mapCollection(OperationalStatusBuilder.fromJson, list)
      ) : [];
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/operational-status.builder.ts